import { configureStore } from '@reduxjs/toolkit';

import DashboardsliceReducer from './Dashboardslice';
import ExploresliceReducer from './Exploreslice';
import OnboardingSliceReducer from './OnboardingSlice';
import portfolioSlice from './PortfolioSlice';
import UapiUserSlice from './UapiUserSlice';

const store = configureStore({
  reducer: {
    Dashboard: DashboardsliceReducer,
    Explore: ExploresliceReducer,
    User: UapiUserSlice,
    portfolio: portfolioSlice,
    onboarding: OnboardingSliceReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
